import React from 'react'

export default function GolfCourseSplitLayout({ heroImageUrl, heroPosition = '50% 50%', children }) {
  return (
    <div className="mp-golf-layout">
      <div
        className="mp-golf-hero"
        style={
          heroImageUrl
            ? {
                '--mp-golf-hero-photo': `url(${heroImageUrl})`,
                '--mp-golf-hero-position': heroPosition,
              }
            : undefined
        }
      >
        <div className="mp-golf-hero__image" aria-hidden />
      </div>

      <div className="mp-golf-content">{children}</div>
    </div>
  )
}
